export default __webpack_public_path__ + "/dist/images/buyer.69ecde3e1aae4ec02f5e2c2507525d3e.png";